module.exports = __webpack_public_path__ + "static/media/1280px-Neutrogena_logo.svg.765a15f9.png";